import React, { useEffect } from 'react';

const SesiSupportBtn = () => {
  useEffect(() => {
    window.fwSettings = {
      widget_id: 9000000871
    };

    if (typeof window.FreshworksWidget !== 'function') {
      const n = (...args) => {
        n.q.push(args);
      };
      n.q = [];
      window.FreshworksWidget = n;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://widget.freshworks.com/widgets/9000000871.js';
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return <></>;
};

export default SesiSupportBtn;
